const HERO_BG =
  "https://public.readdy.ai/ai/img_res/d91687c192c36731c4ad845c30c7e68a.jpg";

export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative w-full flex items-center justify-center overflow-hidden"
      style={{ minHeight: "100vh" }}
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={HERO_BG}
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-8 flex flex-col items-center text-center pt-20">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/30 rounded-full px-5 py-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-teal-400 animate-pulse" />
          <span className="text-teal-300 text-sm font-medium tracking-wider uppercase">
            iOS App Development
          </span>
        </div>

        {/* Heading */}
        <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight tracking-tight max-w-4xl">
          Crafting Premium
          <br />
          <span className="text-teal-400">iOS Experiences</span>
        </h1>

        {/* Subtitle */}
        <p className="mt-8 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed font-light">
          We build sophisticated mobile applications that prioritize security,
          performance, and exceptional user experience — designed exclusively for
          the iOS platform.
        </p>

        {/* Scroll cue */}
        <div className="mt-16 flex flex-col items-center gap-2 text-white/40">
          <span className="text-xs uppercase tracking-widest">Scroll</span>
          <i className="ri-arrow-down-line text-xl animate-bounce" />
        </div>
      </div>
    </section>
  );
}
